import { render, staticRenderFns } from "./teacherRegister.vue?vue&type=template&id=6905c3f0&scoped=true"
import script from "./teacherRegister.vue?vue&type=script&lang=js"
export * from "./teacherRegister.vue?vue&type=script&lang=js"
import style0 from "./teacherRegister.vue?vue&type=style&index=0&id=6905c3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6905c3f0",
  null
  
)

export default component.exports